import { v4 as uuid } from 'uuid';

export const GENERAL = 'General';
export const DISCOUNT_OPTIONS = {
  value: 'value',
  percentage: 'percentage',
};

export const ALERT_MESSAGES = {
  Client:
    'You cannot switch the responsibility to "Client" for this task because there are allocated hours/value. To change the responsibility, please remove the hours/value in the budget builder and save or add a new client task.',
  deleteTask: 'Unable to delete the sole task below a deliverable.',
  Deliverable: 'The sole deliverable in the timeline cannot be deleted.',
  Delete:
    'Deleting this deliverable will also remove any associated information. Do you want to proceed?',
  General: 'You do not have permission to save.',
  SaveProject:
    'Unable to save project plan. Please add at least one material OR specify one deliverable and task description to proceed.',
  SaveProjectFixedFee:
    'Unable to save project plan. Please specify at least one deliverable to proceed.',
  SaveProjectTimeAndMaterials:
    'Unable to save project plan. Please specify at least one deliverable and task description to proceed.',
  SaveProjectMaterials: 'Unable to save project plan. Please add at least one material to proceed.',
  Responsibility: 'Each task must have a responsibility selected.',
  SelectedType: 'Each material must have an expense type selected.',
  MaterialDescription: 'Each material with a cost and quantity must have a description.',
  DeliverableNameRequired: 'Deliverable Name is a required to save.',
  TaskDescriptionRequired: 'Task Description is required to save.',
  DateDescription: 'A task end date cannot be earlier than the start date.',
  ProjectPlanDescription:
    "Hold on! Your project plan changes have not been saved. If you proceed, you will lose your changes. Press 'Cancel' to go back to your plan.",
  DeleteMaterialDescription: 'Unable to delete the sole material in a project plan.',
  AddBudgetDescription: 'You must specify a Deliverable name and Task description to add a budget.',
  CongratulationsMsg: 'Congratulations! Your project plan has been saved.',
  DeleteDeliveravle:
    'Unable to delete deliverable. You cannot delete a deliverable with value allocated to it OR time logged against it.',
  ChangeResponsibility:
    'Unable to change responsibility. You cannot switch the responsibility to "Client" for a task with a value allocated in the budget.',
  UnableToDeleteTask:
    'Unable to delete task. You cannot delete a task with a value allocated in the budget.',
  IncorrectDates: 'Date range relies on tasks.',
};

export const DEFAULT_MILESTONE = [
  {
    name: '',
    dateRange: '',
    id: uuid(),
    tasks: [
      {
        description: '',
        id: uuid(),
        organization: 'FKA',
        hours: 0,
        budget: 0,
        startDate: null,
        endDate: null,
        isRequired: true,
        resources: [
          {
            hours: 0,
            id: uuid(),
            isEnabled: false,
          },
        ],
      },
    ],
    hours: 0,
    budget: 0,
  },
];

export const DEFAULT_MATERIALS = [
  {
    cost: '',
    description: '',
    expenseType: '',
    markup: '',
    orderNumber: 'N/A',
    override: '',
    quantity: '',
    total: '',
  },
];

export const PLANNER_TYPES = [
  { label: 'Fixed-Fee Deliverable', value: 'Fixed Fee Deliverable' },
  { label: 'Fixed-Fee Project', value: 'Fixed Fee Project' },
  { label: 'Material-Only', value: 'Materials' },
  { label: 'Time + Materials', value: 'Time + Materials' },
];

export const DEFAULT_PLANNER_STATE = {
  projectData: {
    flowId: '',
    acceloId: '',
    acceloTitle: '',
    client: '',
    projectName: '',
    projectScope: '',
    status: '',
    plannerType: '',
    plannerStartDate: '',
    plannerEndDate: '',
    plannerServiceValue: 0,
    rateOption: '',
  },
  milestones: DEFAULT_MILESTONE,
  materials: DEFAULT_MATERIALS,
  templateBuilderData: null,
  byPassTemplateSelection: false, // To bypass template selection
  serviceDiscount: 0,
  serviceDiscountUnit: DISCOUNT_OPTIONS.value,
  materialDiscount: 0,
  materialDiscountUnit: DISCOUNT_OPTIONS.value,
  resources: [],
};
